import getYear from 'date-fns/getYear';
import getMonth from 'date-fns/getMonth';

const parseLabels = value => `${getYear(new Date(value))}/${getMonth(new Date(value)) + 1}`;

export const summaryCardHistoryParser = values =>
  values && values.data
    ? values.data.map((value, index) => ({
        data: value,
        label: parseLabels(values.labels[index]),
      }))
    : [];
